import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable()
export class ForwardingApi extends HttpClient {
    private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/forwarding' : environment.baseUrl + '/forwarding';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public forwardError(sessionToken: string): Observable<any> {
      const url = this.baseUrl + `/error/${sessionToken}`;
      return super.get(url);
    }

}
